import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { globalTheme } from '@playbookux/playbook-web-core';
import {
  Container,
} from './styles';
import HeaderShow from './header-show';
import BodyTimeShow from './body-time-show';
import useWindowDimensions from '../../../../core/hooks/use-window-dimensions';

const MAX_MOBILE_SCREEN_WIDTH = globalTheme.breakpoints.sm - 1;
const SEVEN_DAYS_PER_PAGE = 7;
const THREE_DAYS_PER_PAGE = 3;

const DATE_FORMAT = 'LT';
const FORMAT_24H = 'kk:mm';

const CalendarTimePicker = (props) => {
  const {
    dataAudience,
    initialDate,
    loading,
    onInitialDateChange,
    onTimeChange,
    selectedTime,
    timeSlots,
    timeZone,
    toggleTime,
    history,
  } = props;

  const timeFormat = toggleTime ? FORMAT_24H : DATE_FORMAT;

  const today = moment().startOf('day');
  const { width } = useWindowDimensions();
  const totalDays = width > MAX_MOBILE_SCREEN_WIDTH ? SEVEN_DAYS_PER_PAGE : THREE_DAYS_PER_PAGE;

  const initialDaysOfWeek = (value = initialDate) => Array(totalDays)
    .fill(value)
    .map((date, index) => moment(date).add(index, 'days'));

  const [daysOfWeek, setDaysOfWeek] = useState(initialDaysOfWeek(today));

  const onDaysOfWeek = (date) => {
    onInitialDateChange(date.toISOString());
    setDaysOfWeek(initialDaysOfWeek(date));
  };

  const onNextDay = () => {
    const date = initialDate.add(1, 'days');
    onDaysOfWeek(date);
  };

  const onPreviousDay = () => {
    const date = moment(initialDate).subtract(1, 'days');
    if (date >= today) {
      onDaysOfWeek(date);
    }
  };

  return (
    <Container>

      <HeaderShow
        daysOfWeek={daysOfWeek}
        onNextDay={onNextDay}
        onPreviousDay={onPreviousDay}
        today={today}
        totalDays={totalDays}
      />

      <BodyTimeShow
        timeSlots={timeSlots}
        daysOfWeek={daysOfWeek}
        selectedTime={selectedTime}
        onTimeChange={onTimeChange}
        timeZone={timeZone}
        loading={loading}
        timeFormat={timeFormat}
        dataAudience={dataAudience}
        history={history}
      />

    </Container>
  );
};

CalendarTimePicker.propTypes = {
  onTimeChange: PropTypes.func.isRequired,
  selectedTime: PropTypes.string,
  timeZone: PropTypes.string,
  timeSlots: PropTypes.oneOfType([PropTypes.array]).isRequired,
  onInitialDateChange: PropTypes.func.isRequired,
  initialDate: PropTypes.oneOfType([PropTypes.object]).isRequired,
  loading: PropTypes.bool.isRequired,
  toggleTime: PropTypes.bool,
  dataAudience: PropTypes.shape(),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

CalendarTimePicker.defaultProps = {
  toggleTime: false,
  selectedTime: null,
  timeZone: null,
  dataAudience: {},
};

export default CalendarTimePicker;
